import { render, staticRenderFns } from "./colored-products-categories-list.vue?vue&type=template&id=2cf56622"
import script from "./colored-products-categories-list.vue?vue&type=script&lang=js"
export * from "./colored-products-categories-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports